import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-pharmacie-edit-modal',
  templateUrl: './pharmacie-edit-modal.component.html',
  styleUrls: ['./pharmacie-edit-modal.component.scss']
})
export class PharmacieEditModalComponent implements OnInit {
  public afficherContactSupport = false;

  @Output()
  private modalStateChanged: EventEmitter<boolean> = new EventEmitter();

  sendFormSubject: Subject<void> = new Subject<void>();
  sendContactSupportFormSubject: Subject<void> = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.modalStateChanged.emit(true);
  }

  closeModal() {
    this.modalStateChanged.emit(false);
  }

  formSended($event: any) {
    this.closeModal();
  }

  sendForm() {
    this.sendFormSubject.next();
  }

  afficherModalContactSupport(){
    this.afficherContactSupport = true;
  }

  changeAfficherContactSupport(event){
    this.afficherContactSupport = event
  }

}
